module.exports = __webpack_public_path__ + "static/media/btcz_paper_back.b84e6486.png";


//////////////////
// WEBPACK FOOTER
// ./src/btcz_paper_back.png
// module id = ./src/btcz_paper_back.png
// module chunks = 0